import CaseRecommendationIcon from '@cp/src/assets/icons/CaseRecommendationIcon';
import { Typography } from '@navi/web-ui/lib/primitives';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import {
  ContactableStatus,
  PtpStatus,
  PtpStatusLabel
} from '@cp/src/pages/CaseRecommendation/types';
import VerticalSeperator from '@cp/src/components/VerticalSeperator';
import { FeedbackTypesCodeMap } from '@cp/src/pages/Cases/constants/CasesConstants';
import { isToday, formatEpochTime } from '@cp/src/utils/DateHelper';

const RecommendedCaseBox = () => {
  const caseRecommendedAttributes = useSelector(
    (state: RootState) => state.caseRecommendation.currentRecommendedCase.attributes
  );
  const isContactedToday = caseRecommendedAttributes?.latestInteractionTimestamp
    ? isToday(formatEpochTime(caseRecommendedAttributes.latestInteractionTimestamp).toString())
    : false;
  return (
    <div className="bg-gradient-to-r from-[var(--blue-base)] to-[var(--blue-border)] p-[1px] rounded-xl mx-6 mt-4 mb-2">
      <div className="flex flex-row justify-between items-center rounded-xl px-3 bg-gradient-to-r from-[var(--blue-bg)] to-[var(--bg-primary)] gap-4">
        <div className="flex flex-row gap-2 items-center">
          <Typography variant="p3" color="var(--blue-dark)">
            {PtpStatusLabel[caseRecommendedAttributes?.ptpState as keyof typeof PtpStatus]}
          </Typography>
          {caseRecommendedAttributes?.ptpState && (
            <VerticalSeperator height="18px" color="var(--blue-dark)" />
          )}
          <Typography variant="p3" color="var(--blue-dark)">
            {FeedbackTypesCodeMap[caseRecommendedAttributes?.latestDisposition]?.label}
          </Typography>
          {caseRecommendedAttributes?.latestDisposition && (
            <VerticalSeperator height="18px" color="var(--blue-dark)" />
          )}
          <Typography variant="p3" color="var(--blue-dark)">
            {isContactedToday
              ? ContactableStatus.ATTEMPTED_TODAY
              : ContactableStatus.NOT_ATTEMPTED_TODAY}
          </Typography>
        </div>
        <CaseRecommendationIcon width={40} height={40} />
      </div>
    </div>
  );
};

export default RecommendedCaseBox;
